import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { GeneralSettingsService } from '../../general-settings/general-settings.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslatableTextTranslationsDialogComponent } from './translatable-text-translations-dialog/translatable-text-translations-dialog.component';

@Component({
  selector: 'translatable-text-input',
  templateUrl: './translatable-text-input.component.html',
  styleUrls: ['./translatable-text-input.component.scss']
})
export class TranslatableTextInputComponent implements OnInit, OnDestroy {
  @Input() translatableGroup: FormGroup;
  @Input() placeholder: string = 'Enter Confirmation Text';
  @Input() dialogTitle: string = 'Manage Translations';
  languages: any[] = [];
  private _unsubscribeAll: Subject<any> = new Subject();

  constructor(
    public generalSettingsService: GeneralSettingsService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.generalSettingsService.getLanguages().then(langs => {
      this.languages = Array.isArray(langs) ? langs : [];
    });
    
    this.generalSettingsService.onLanguagesChanged
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(languages => {
        if (Array.isArray(languages)) {
          this.languages = languages;
        }
      });
  }

  ngOnDestroy() {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  get translationsControl() {
    return this.translatableGroup.get('translations');
  }

  get translatedCount(): number {
    const currentTranslations = this.translationsControl.value || {};
    let count = 0;
    this.languages.forEach(lang => {
      const trans = currentTranslations[lang.code];
      if (trans && trans.trim() !== '') {
        count++;
      }
    });
    return count;
  }

  openManageTranslationsDialog() {
    this.dialog.open(TranslatableTextTranslationsDialogComponent, {
      width: '600px',
      maxHeight: '90vh',
      data: {
        formGroup: this.translatableGroup,
        title: this.dialogTitle
      }
    });
  }
}
